module.exports = __webpack_public_path__ + "static/media/onboard-content1.3937b8a3.png";